import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Checkbox } from 'semantic-ui-react';
import _ from 'lodash';
import * as AppActions from '../../../actions';

class WrapperTabCheckbox extends Component {
  componentDidUpdate(prevProps) {
    const {
      showCheckboxesMultiQc: prevInMultiQc,
      showCheckboxes: prevShowCheckboxes
    } = prevProps;
    const {
      showCheckboxesMultiQc: currInMultiQc,
      showCheckboxes: currShowCheckboxes,
      indeterminateCampaigns,
      checkedCampaigns,
      selectedAds,
      actions
    } = this.props;
    let mode;

    if (prevInMultiQc !== currInMultiQc) {
      mode = 'multiQc';
    } else if (prevShowCheckboxes !== currShowCheckboxes) {
      mode = 'shareAds';
    } else {
      mode = '';
    }

    if (mode) {
      const newCheckedCampaigns = _.mapValues(
        checkedCampaigns,
        () => mode === 'shareAds'
      );
      actions.updateAdPreviewData(
        selectedAds,
        newCheckedCampaigns,
        indeterminateCampaigns
      );
    }
  }

  handleCheckChange = (e, { name, checked }) => {
    const {
      selectedAds,
      checkedCampaigns,
      indeterminateCampaigns,
      campaignMonth,
      campaignKey,
      actions
    } = this.props;
    const key = name;
    if (checked) {
      checkedCampaigns[campaignKey] = true;
      selectedAds[key] = campaignMonth[key].map((ad) => {
        const {
          ad_id: adId,
          ad_original_name: adOriginalName,
          desktop_iframe_url: desktopIframeUrl,
          mobile_iframe_url: mobileIframeUrl,
          adQc
        } = ad;
        const urls = {
          desktopUrl: desktopIframeUrl,
          mobileUrl: mobileIframeUrl
        };
        return {
          id: adId,
          name: adOriginalName,
          adQc,
          urls
        };
      });
    } else {
      selectedAds[key] = [];
      checkedCampaigns[campaignKey] = false;
    }

    checkedCampaigns[key] = checked;
    indeterminateCampaigns[key] = false;

    actions.updateAdPreviewData(
      selectedAds,
      checkedCampaigns,
      indeterminateCampaigns
    );
    e.stopPropagation();
  };

  render() {
    const {
      showCheckboxes,
      showCheckboxesMultiQc,
      checkedCampaigns,
      indeterminateCampaigns,
      campaignKey
    } = this.props;
    if (showCheckboxes || showCheckboxesMultiQc) {
      return (
        <Checkbox
          indeterminate={indeterminateCampaigns[campaignKey]}
          checked={checkedCampaigns[campaignKey]}
          className="select-account"
          name={campaignKey}
          type="checkbox"
          onChange={(event, data) => {
            this.handleCheckChange(event, data);
          }}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  const { adPreview } = state;
  const {
    selectedAds,
    checkedCampaigns,
    indeterminateCampaigns,
    showCheckboxes,
    showCheckboxesMultiQc
  } = adPreview;
  const newProps = Object.assign({}, state, {
    selectedAds,
    checkedCampaigns,
    indeterminateCampaigns,
    showCheckboxes,
    showCheckboxesMultiQc
  });
  return newProps;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(WrapperTabCheckbox);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/WrapperTabCheckbox.js